import type { HTMLAttributes } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


export type PillTone = "neutral" | "rosette";

const TONE_CLASSES: Record<PillTone, string> = {
    neutral: "bg-chip text-on-light",
    rosette: "bg-rosette text-on-light",
};


interface PillProps extends HTMLAttributes<HTMLSpanElement> {
    tone?: PillTone;
}


/**
 * A short label on a coloured background, such as a role tag. Other
 * colours go in `className` as role classes, such as "bg-role-gold text-white".
 */
export function Pill({ tone = "neutral", className, children, ...props }: PillProps) {
    return (
        <span
            className={cn(
                "inline-block rounded-sm px-2 py-1 text-sm font-bold shadow-md",
                TONE_CLASSES[tone],
                className ?? null,
            )}
            {...props}>

            {children}
        </span>
    );
}
